import { useCallback, useEffect, useState } from "react";
import { listManufacturingOrgSlotLabels } from "@/lib/manufacturingClient";

export function useManufacturingOrgSlotLabels(enabled: boolean, refreshKey = 0) {
  const [labels, setLabels] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!enabled) {
      setLabels([]);
      return;
    }
    setLoading(true);
    const res = await listManufacturingOrgSlotLabels();
    setLoading(false);
    if (res.ok) setLabels(res.data.labels);
  }, [enabled]);

  useEffect(() => {
    void reload();
  }, [reload, refreshKey]);

  return { labels, loading, reload };
}
